import {
  getAuthAccessToken,
  getAuthorizationHeader
} from '@/adapters/authAccessToken';
import { Fetcher } from '@/adapters/fetcher';

export default new Fetcher({
  prefixUrl: `https://${import.meta.env.VITE_AUTH0_DOMAIN}/`,
  beforeInit: [
    async (input, init) => {
      const token = await getAuthAccessToken();
      init.headers['Authorization'] = getAuthorizationHeader(token);
    }
  ]
});
